/**
 * Version 0.100
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 *
 * 2025
 * 29-09-2025
 * - [CHANGE] Unbind unnecessary events are gone
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_init = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

		/**
		 * Close the mobilemenu always on route
		 */
		specific_mobilemenu.toggle(1);

		/**
		 * Catch and active URL
		 */
		specific_interactions.catchAndActiveURL();

		/**
		 * Trigger: specific classes
		 */
		specific_interactions_init.homePreloader();


	};

	/**
	 * Home Preloader
	 */
	this.homePreloader = function () {

		var preloader = document.querySelector('.page.home .js-home-preloader');
		if (!preloader) {
			specific_interactions_init.homeCanvasScroller();
			specific_interactions_init.homeArtworkOverlay();
			return;
		}

		var preloadSource = preloader.getAttribute('data-preload-src');
		var preloadProgress = preloader.querySelector('.js-home-preloader-progress');
		var preloadImage = new Image();
		var hasFinished = false;
		var minVisibleTime = 6500;
		var startTime = Date.now();
		var imageLoaded = false;
		var minTimeReached = false;
		var minTimeTimer = null;
		var progressTimer = null;
		var countdownStart = 10;
		var countdownValue = countdownStart;

		function setCountdown(nextValue) {
			if (!preloadProgress) {
				return;
			}

			countdownValue = Math.max(0, Math.min(countdownStart, nextValue));
			preloadProgress.textContent = countdownValue;
		}

		function startProgressAnimation() {
			if (!preloadProgress) {
				return;
			}

			var stepDelay = Math.max(350, Math.floor(minVisibleTime / countdownStart));
			var lastStepAt = Date.now();

			progressTimer = window.setInterval(function () {
				if (
					countdownValue > 1 &&
					(Date.now() - lastStepAt) >= stepDelay
				) {
					setCountdown(countdownValue - 1);
					lastStepAt = Date.now();
				}

				if (imageLoaded && minTimeReached) {
					if (countdownValue > 1) {
						setCountdown(1);
					}

					maybeStartHome();
				}
			}, 40);
		}

		function maybeStartHome() {
			if (hasFinished || !imageLoaded || !minTimeReached) {
				return;
			}

			hasFinished = true;

			if (countdownValue > 1) {
				setCountdown(1);
			}

			if (progressTimer) {
				window.clearInterval(progressTimer);
				progressTimer = null;
			}

			preloader.classList.add('is-hidden');

			setTimeout(function () {
				if (preloader.parentNode) {
					preloader.parentNode.removeChild(preloader);
				}

				specific_interactions_init.homeCanvasScroller();
				specific_interactions_init.homeArtworkOverlay();
			}, 450);
		}

		function startHome() {
			if (hasFinished) {
				return;
			}

			imageLoaded = true;
			maybeStartHome();
		}

		minTimeTimer = window.setTimeout(function () {
			minTimeReached = true;
			maybeStartHome();
		}, minVisibleTime);

		setCountdown(countdownStart);
		startProgressAnimation();

		preloadImage.onload = startHome;
		preloadImage.onerror = startHome;
		preloadImage.src = preloadSource;

		if (preloadImage.complete) {
			startHome();
		}

		if ((Date.now() - startTime) >= minVisibleTime) {
			minTimeReached = true;
		}

		if (preloadImage.complete && minTimeReached) {
			maybeStartHome();
		}

	};

	/**
	 * Canvas Scroller
	 */
	this.homeCanvasScroller = function () {

		var canvas = document.querySelector('.page.home .canvas');
		var scroller = document.querySelector('.page.home .canvas--scroller');
		var titleBar = document.querySelector('.page.home .js-title-bar');
		var homeActions = document.querySelectorAll('.page.home .js-home-actions');
		var scrollHint = document.querySelector('.page.home .js-home-scroll-hint');
		var scrollProgress = document.querySelector('.page.home .js-home-scroll-progress');
		var backToBeginButton = document.querySelector('.page.home .js-home-back-to-begin');
		var toArtworkButton = document.querySelector('.page.home .js-home-to-artwork');
		var mobileQuery = window.matchMedia('(max-width: 991px)');

		if (!canvas || !scroller || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || typeof ScrollToPlugin === 'undefined') {
			return;
		}

		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

		if (canvas._homeCanvasScrollerCleanup) {
			canvas._homeCanvasScrollerCleanup();
		}

		var trigger = null;
		var tween = null;
		var scrollTween = null;

		var isDragging = false;
		var pointerId = null;

		var startX = 0;
		var startY = 0;
		var startScrollY = 0;

		var lastX = 0;
		var lastTime = 0;
		var velocityX = 0;

		var dragMultiplier = 1.4;
		var momentumMultiplier = 850;
		var isTitleBarHidden = false;
		var isHomeActionsHidden = true;
		var isScrollHintHidden = false;

		function setTitleBarHidden(hidden, immediate) {
			if (!titleBar || isTitleBarHidden === hidden) {
				return;
			}

			isTitleBarHidden = hidden;

			gsap.to(titleBar, {
				xPercent: hidden ? 120 : 0,
				autoAlpha: hidden ? 0 : 1,
				duration: immediate ? 0 : 0.35,
				ease: 'power2.out',
				overwrite: true
			});
		}

		function setHomeActionsHidden(hidden, immediate) {
			if (!homeActions.length || isHomeActionsHidden === hidden) {
				return;
			}

			isHomeActionsHidden = hidden;

			homeActions.forEach(function (actionsElement) {
				var isLeftActions = actionsElement.classList.contains('canvas__actions--left');
				gsap.to(actionsElement, {
					xPercent: hidden ? (isLeftActions ? -120 : 120) : 0,
					autoAlpha: hidden ? 0 : 1,
					duration: immediate ? 0 : 0.35,
					ease: 'power2.out',
					overwrite: true
				});
			});
		}

		function setScrollHintHidden(hidden, immediate) {
			if (!scrollHint || isScrollHintHidden === hidden) {
				return;
			}

			isScrollHintHidden = hidden;

			gsap.to(scrollHint, {
				y: hidden ? 10 : 0,
				autoAlpha: hidden ? 0 : 1,
				duration: immediate ? 0 : 0.3,
				ease: 'power2.out',
				overwrite: true
			});
		}

		function setScrollProgress(progressValue) {
			if (!scrollProgress) {
				return;
			}

			gsap.set(scrollProgress, {
				scaleX: clamp(progressValue, 0, 1)
			});
		}

		function getDistance() {
			return Math.max(0, scroller.scrollWidth - window.innerWidth);
		}

		function clamp(value, min, max) {
			return Math.max(min, Math.min(value, max));
		}

		function getStart() {
			return trigger ? trigger.start : 0;
		}

		function getEnd() {
			return trigger ? trigger.end : 0;
		}

		function killScrollTween() {
			if (scrollTween) {
				scrollTween.kill();
				scrollTween = null;
			}
		}

		function scrollToY(y, duration) {
			killScrollTween();

			scrollTween = gsap.to(window, {
				scrollTo: {
					y: y,
					autoKill: false
				},
				duration: duration || 0.75,
				ease: 'power3.out',
				overwrite: true
			});
		}

		function scrollToHomeStart(duration) {
			scrollToY(getStart(), duration || 0.9);
		}

		function scrollToArtworkStart(duration) {
			var distance = getDistance();
			var targetY = getStart() + (distance * 0.38);

			scrollToY(targetY, duration || 0.9);
		}

		function isInteractiveTarget(target) {
			if (!target || !target.closest) {
				return false;
			}

			return !!target.closest('a, button, input, textarea, select, label, summary, [contenteditable="true"], .intro-scroller');
		}

		function down(event) {
			if (isInteractiveTarget(event.target)) {
				return;
			}

			if (event.target && event.target.closest && event.target.closest('.js-bttn-click, .js-artwork-overlay, .js-home-actions, .js-home-back-to-begin, .js-home-to-artwork')) {
				return;
			}

			if (event.button !== 0 && event.pointerType === 'mouse') {
				return;
			}

			if (!trigger || getDistance() <= 0) {
				return;
			}

			isDragging = true;
			pointerId = event.pointerId;

			startX = event.clientX;
			startY = event.clientY;
			startScrollY = window.scrollY;

			lastX = startX;
			lastTime = Date.now();
			velocityX = 0;

			killScrollTween();

			canvas.classList.add('is-dragging');

			if (canvas.setPointerCapture) {
				canvas.setPointerCapture(pointerId);
			}

			event.preventDefault();
		}

		function move(event) {
			if (!isDragging || event.pointerId !== pointerId) {
				return;
			}

			var now = Date.now();
			var x = event.clientX;

			var deltaX = x - startX;
			var targetY = startScrollY - deltaX * dragMultiplier;

			targetY = clamp(targetY, getStart(), getEnd());

			window.scrollTo(0, targetY);

			var dt = now - lastTime;
			if (dt > 0) {
				velocityX = (x - lastX) / dt;
				lastX = x;
				lastTime = now;
			}

			event.preventDefault();
		}

		function up(event) {
			if (!isDragging) {
				return;
			}

			if (event && event.pointerId !== pointerId) {
				return;
			}

			isDragging = false;
			pointerId = null;

			canvas.classList.remove('is-dragging');

			var momentum = velocityX * momentumMultiplier;
			var targetY = window.scrollY - momentum;

			targetY = clamp(targetY, getStart(), getEnd());

			scrollToY(targetY, 0.85);
		}

		tween = gsap.to(scroller, {
			x: function () {
				return -getDistance();
			},
			ease: 'none',
			scrollTrigger: {
				trigger: canvas,
				start: 'top top',
				end: function () {
					return '+=' + getDistance();
				},
				scrub: true,
				pin: true,
				anticipatePin: 1,
				invalidateOnRefresh: true,
				onRefresh: function (self) {
					trigger = self;
				},
				onUpdate: function (self) {
					trigger = self;

					// Keep title bar visible only at the first screen.
					setTitleBarHidden(self.progress > 0.01, false);
					setHomeActionsHidden(self.progress < 0.16, false);
					setScrollHintHidden(self.progress > 0.02, false);
					setScrollProgress(self.progress);
				}
			}
		});

		setTitleBarHidden(false, true);
		setHomeActionsHidden(true, true);
		setScrollHintHidden(false, true);
		setScrollProgress(0);

		function onBackToBeginClick(event) {
			event.preventDefault();
			scrollToHomeStart(0.85);
		}

		function onToArtworkClick(event) {
			event.preventDefault();
			scrollToArtworkStart(0.85);
		}

		function onViewportChange() {
			setHomeActionsHidden(true, true);
			setScrollHintHidden(false, true);
		}

		if (backToBeginButton) {
			backToBeginButton.addEventListener('click', onBackToBeginClick);
		}

		if (toArtworkButton) {
			toArtworkButton.addEventListener('click', onToArtworkClick);
		}

		if (mobileQuery.addEventListener) {
			mobileQuery.addEventListener('change', onViewportChange);
		} else if (mobileQuery.addListener) {
			mobileQuery.addListener(onViewportChange);
		}

		canvas.addEventListener('pointerdown', down);
		window.addEventListener('pointermove', move, { passive: false });
		window.addEventListener('pointerup', up);
		window.addEventListener('pointercancel', up);

		canvas._homeCanvasScrollerCleanup = function () {
			canvas.removeEventListener('pointerdown', down);
			window.removeEventListener('pointermove', move);
			window.removeEventListener('pointerup', up);
			window.removeEventListener('pointercancel', up);

			if (backToBeginButton) {
				backToBeginButton.removeEventListener('click', onBackToBeginClick);
			}

			if (toArtworkButton) {
				toArtworkButton.removeEventListener('click', onToArtworkClick);
			}

			if (mobileQuery.removeEventListener) {
				mobileQuery.removeEventListener('change', onViewportChange);
			} else if (mobileQuery.removeListener) {
				mobileQuery.removeListener(onViewportChange);
			}

			killScrollTween();

			if (tween) {
				tween.kill();
			}

			if (titleBar) {
				gsap.killTweensOf(titleBar);
				gsap.set(titleBar, {
					clearProps: 'transform,opacity,visibility'
				});
			}

			homeActions.forEach(function (actionsElement) {
				gsap.killTweensOf(actionsElement);
				gsap.set(actionsElement, {
					clearProps: 'transform,opacity,visibility'
				});
			});

			if (scrollHint) {
				gsap.killTweensOf(scrollHint);
				gsap.set(scrollHint, {
					clearProps: 'transform,opacity,visibility'
				});
			}

			if (scrollProgress) {
				gsap.set(scrollProgress, {
					clearProps: 'transform'
				});
			}

			gsap.set(scroller, {
				clearProps: 'transform'
			});

			canvas.classList.remove('is-dragging');
		};

		ScrollTrigger.refresh();

	};

	/**
	 * Artwork Overlay
	 */
	this.homeArtworkOverlay = function () {

		var overlay = document.querySelector('.page.home .js-artwork-overlay');
		var overlayTitle = document.querySelector('.page.home .js-artwork-overlay #artwork-overlay-title');
		var overlayBuy = document.querySelector('.page.home .js-artwork-overlay .js-artwork-overlay-buy');
		var overlayDescription = document.querySelector('.page.home .js-artwork-overlay #artwork-overlay-description');
		var overlayKicker = document.querySelector('.page.home .js-artwork-overlay .js-artwork-overlay-kicker');
		var overlayImage = document.querySelector('.page.home .js-artwork-overlay .js-artwork-overlay-image');
		var overlayMetaSize = document.querySelector('.page.home .js-artwork-overlay .js-artwork-overlay-meta-size');
		var overlayMetaMedium = document.querySelector('.page.home .js-artwork-overlay .js-artwork-overlay-meta-medium');
		var overlayMetaMaterial = document.querySelector('.page.home .js-artwork-overlay .js-artwork-overlay-meta-material');
		var openButtons = document.querySelectorAll('.page.home .js-bttn-click');

		if (!overlay || !overlayTitle || !overlayDescription || !overlayKicker || !overlayImage || !openButtons.length || typeof gsap === 'undefined') {
			return;
		}

		if (overlay._homeArtworkOverlayCleanup) {
			overlay._homeArtworkOverlayCleanup();
		}

		var defaultArtworkMeta = {
			size: 'Φ 25 cm',
			medium: 'Canvas',
			material: 'Bontanisch materiaal',
			price: ''
		};

		var artworkData = {
			'annemaria-koekoek': {
				title: 'Annemaria Koekoek',
				size: 'Φ 25 cm',
				medium: 'Canvas',
				material: 'Gedroogde planten',
				price: '€ 545 incl. BTW',
				description: 'In mijn jeugd was de boom het vertrekpunt van mijn speeltuin. De natuurlijke boom, gemaakt van camelia zorgt voor volop beweging en interactie. Van de vier figuren vormt een takje dille het haar van een figuur, het oog is bijv. een lavendelbolletje.',
				kicker: 'Vier figuren in een boom',
				thumb: 'artwork-annemaria-koekkoek.webp',
			},
			'hinkelen': {
				title: 'Hinkelen',
				size: 'Φ 30 cm',
				medium: 'Canvas',
				material: 'Gedroogde planten',
				price: '€ 435 inc. btw',
				description: 'Vanuit een helikopter view, kan hinkelen overal gebeuren. Met de schaduw van de blaadjes erbij, een klein dansje met de voetjes terwijl de getallen worden getelt.',
				kicker: 'Onder en in de schaduw',
				thumb: 'artwork-hinkelen.webp'
			},
			'touwtje-springen': {
				title: 'Touwtje Springen',
				size: 'Φ 25 cm',
				medium: 'Canvas',
				material: 'Gedroogde planten',
				price: '€ 545 inc. btw',
				description: 'Juist in de regen gaat het door, waarbij elementen uit de stad Amersfoort, zoals een staande lamp, onderdeel van het spel worden. Zelfs een geel vogeltje gemaakt met de Chinese klokjes wordt aangetrokken.',
				kicker: 'Stad en haar beweging',
				thumb: 'artwork-touwtje-springen.webp'
			},
			'knikkeren': {
				title: 'Knikkeren',
				size: 'Φ 30 cm',
				medium: 'Canvas',
				material: 'Gedroogde planten',
				price: '€ 599 inc. btw',
				description: 'Zonder aandacht hoor je de klik niet makkelijk. Daarom is het nodig om dicht bij de grond te zijn. Maar de gedachte kan zomaar wegdrijven, net als de luchtballon, gemaakt van paprika zaden en herfstanemonen.',
				kicker: 'Klik en vooruit',
				thumb: 'artwork-knikkeren.webp'
			},
			'vliegeren': {
				title: 'Vliegeren',
				size: 'Φ 25 cm',
				medium: 'Canvas',
				material: 'Gedroogde planten',
				price: '€ 599 inc. btw',
				description: 'Een ode aan het traditionele ambacht van het maken van zwaluwvliegers in Beijing. Een geurige zwaluwvlieger met lavendel, die de frisse lucht en de melancholie opzweept.',
				kicker: 'Ambacht en door',
				thumb: 'artwork-vliegeren.webp'
			},
			'schommelen': {
				title: 'Schommelen',
				size: 'Φ 30 cm',
				medium: 'Canvas',
				material: 'Gedroogde planten',
				price: '€ 490 inc. btw',
				description: 'Achter de klassieke "maanpoort" van kersenbloesem hangt het kronkelende touw van de schommel, gemaakt van de spiralen waarmee de passiebloem zich vastzet. Een uitnodiging om er even tussenuit.',
				kicker: 'Even en tussenuit',
				thumb: 'artwork-schommelen.webp'
			},
			'touwtrekken': {
				title: 'Touwtrekken',
				size: 'Φ 40 cm',
				medium: 'Canvas',
				material: 'Gedroogde planten',
				price: '€ 654 inc. btw',
				description: 'Twee teams met herkenbare teamkleding, de spanning is voelbaar. Het touwtje is gemaakt van Osmanthus bloemen, die de draad van daden in te beelden.',
				kicker: 'Doen en laten',
				thumb: 'artwork-touw-trekken.webp'
			},
			'bezoek-stadhuis-amersfoort': {
				title: 'Bekijk Speel Maar in het echt',
				title_html: 'Bekijk <span class="artwork-overlay__title-accent">Speel Maar</span> in het echt',
				description: 'Stadhuis Amersfoort, Stadhuisplein 1, 3811 LM Amersfoort. Te bekijken tot en met oktober 2026.',
				description_html: 'Stadhuis Amersfoort<br>Stadhuisplein 1, 3811 LM Amersfoort.<br><br>Te bekijken tot en met oktober 2026.<br><br>Meer informatie? <a href="https://www.lucyindelucht.nl/te-zien/de-botanische-kunst-van-ying-yi-wu" target="_blank" rel="noopener noreferrer">klik hier</a> of bezoek Ying Yi Wu op Instagram <a href="https://www.instagram.com/y.y.moon/" target="_blank" rel="noopener noreferrer">@y.y.moon</a> of stuur een e-mail naar <a href="mailto:hello@yingyi.art" target="_blank" rel="noopener noreferrer">hello@yingyi.art</a>',

				kicker: 'Locatie raamkunstwerk',
				buy_disabled: true,
				thumb: 'raamkunstwerk.webp',
				size: '28.85 X 1.78 m',
				medium: 'Canvas',
				material: 'Print'
			}
		};
		var artworkThumbBase = overlay.getAttribute('data-artwork-thumb-base') || '';

		var activeTimeline = null;
		var isOpen = false;
		var openRequestId = 0;

		function getArtworkContent(key) {
			var data = artworkData[key] || artworkData['annemaria-koekoek'];
			var thumbPath = artworkThumbBase ? (artworkThumbBase + '/' + data.thumb) : '';
			var artworkMeta = {
				size: data.size || defaultArtworkMeta.size,
				medium: data.medium || defaultArtworkMeta.medium,
				material: data.material || defaultArtworkMeta.material,
				price: data.price || defaultArtworkMeta.price
			};

			return {
				data: data,
				thumbPath: thumbPath,
				meta: artworkMeta
			};
		}

		function setArtworkContent(artworkContent) {
			var data = artworkContent.data;
			var thumbPath = artworkContent.thumbPath;
			var meta = artworkContent.meta;

			function escapeHtml(value) {
				return String(value)
					.replace(/&/g, '&amp;')
					.replace(/</g, '&lt;')
					.replace(/>/g, '&gt;')
					.replace(/"/g, '&quot;')
					.replace(/'/g, '&#39;');
			}

			function buildBuyMailto(artworkTitle) {
				var subject = 'Interesse in kunstwerk: ' + artworkTitle;
				var body = 'Hoi Ying Yi,\n\nIk heb interesse in het kunstwerk "' + artworkTitle + '". Kun je mij meer informatie sturen over beschikbaarheid en aankoop?\n\nMet vriendelijke groet,';
				return 'mailto:hello@yingyi.art?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
			}

			if (data.title_html) {
				overlayTitle.innerHTML = data.title_html;
			} else {
				overlayTitle.textContent = data.title;
			}

			if (data.description_html) {
				overlayDescription.innerHTML = data.description_html;
			} else {
				overlayDescription.textContent = data.description;
			}
			overlayKicker.textContent = data.kicker || '';

			/**
			* Show pricing and buy contact below the title
			*/
			if (overlayBuy) {
				if (data.buy_disabled) {
					overlayBuy.innerHTML = '';
					overlayBuy.style.display = 'none';
				} else {
					var priceHtml = meta.price ? '<span class="artwork-overlay__buy-price">Prijs: ' + escapeHtml(meta.price) + '</span>' : '';
					var buyLinkHtml = '<a class="artwork-overlay__buy-link" href="' + buildBuyMailto(data.title || 'kunstwerk') + '">Mail om dit kunstwerk te kopen</a>';
					overlayBuy.innerHTML = priceHtml + (priceHtml ? '<br>' : '') + buyLinkHtml;
					overlayBuy.style.display = '';
				}
			}
			overlayImage.src = thumbPath;
			overlayImage.alt = data.title;

			if (overlayMetaSize) {
				overlayMetaSize.textContent = 'Afmeting: ' + meta.size;
			}

			if (overlayMetaMedium) {
				overlayMetaMedium.textContent = 'Drager: ' + meta.medium;
			}

			if (overlayMetaMaterial) {
				overlayMetaMaterial.textContent = 'Materiaal: ' + meta.material;
			}
		}

		function preloadImage(src, onComplete) {
			if (!src) {
				onComplete();
				return;
			}

			if (overlayImage.getAttribute('src') === src && overlayImage.complete && overlayImage.naturalWidth > 0) {
				onComplete();
				return;
			}

			var imageLoader = new Image();
			var done = false;

			function finish() {
				if (done) {
					return;
				}

				done = true;
				onComplete();
			}

			imageLoader.onload = finish;
			imageLoader.onerror = finish;
			imageLoader.src = src;

			if (imageLoader.complete) {
				finish();
			}
		}

		function openOverlay(key) {
			var requestId = openRequestId + 1;
			var artworkContent = getArtworkContent(key);

			openRequestId = requestId;

			preloadImage(artworkContent.thumbPath, function () {
				if (requestId !== openRequestId) {
					return;
				}

				var contentTargets = [overlayKicker, overlayTitle, overlayDescription];
				if (overlayBuy) {
					contentTargets = [overlayKicker, overlayTitle, overlayBuy, overlayDescription];
				}

				setArtworkContent(artworkContent);

				if (activeTimeline) {
					activeTimeline.kill();
				}

				isOpen = true;
				overlay.classList.add('is-open');
				overlay.setAttribute('aria-hidden', 'false');
				document.body.classList.add('no-scroll');

				activeTimeline = gsap.timeline({ defaults: { ease: 'power3.out' } });

				activeTimeline
					.set(overlay, { autoAlpha: 1 })
					.fromTo(overlay.querySelector('.artwork-overlay__backdrop'), { opacity: 0 }, { opacity: 1, duration: 0.25 }, 0)
					.fromTo(overlay.querySelector('.artwork-overlay__dialog'), { y: 40, scale: 0.96, opacity: 0 }, { y: 0, scale: 1, opacity: 1, duration: 0.55 }, 0.04)
					.fromTo(overlayImage, { scale: 1.08, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.55 }, 0.08)
					.fromTo(contentTargets, { y: 18, opacity: 0 }, { y: 0, opacity: 1, duration: 0.4, stagger: 0.06 }, 0.16);
			});
		}

		function closeOverlay() {
			openRequestId = openRequestId + 1;

			if (!isOpen) {
				return;
			}

			isOpen = false;

			if (activeTimeline) {
				activeTimeline.kill();
			}

			activeTimeline = gsap.timeline({ defaults: { ease: 'power2.inOut' } });

			activeTimeline
				.to(overlay.querySelector('.artwork-overlay__dialog'), { y: 24, scale: 0.98, opacity: 0, duration: 0.22 }, 0)
				.to(overlay.querySelector('.artwork-overlay__backdrop'), { opacity: 0, duration: 0.28 }, 0.04)
				.set(overlay, {
					autoAlpha: 0, onComplete: function () {
						overlay.classList.remove('is-open');
						overlay.setAttribute('aria-hidden', 'true');
						document.body.classList.remove('no-scroll');
					}
				}, 0.28);
		}

		function onDocumentClick(event) {
			var openLiveButton = event.target.closest('.page.home .js-home-view-live');
			if (openLiveButton) {
				event.preventDefault();
				openOverlay('bezoek-stadhuis-amersfoort');
				return;
			}

			var openButton = event.target.closest('.page.home .js-bttn-click');
			if (openButton) {
				event.preventDefault();
				openOverlay(openButton.getAttribute('data-artwork'));
				return;
			}

			if (event.target.closest('.page.home .js-artwork-overlay-close')) {
				event.preventDefault();
				closeOverlay();
			}
		}

		function onKeyDown(event) {
			if (event.key === 'Escape') {
				closeOverlay();
			}
		}

		document.addEventListener('click', onDocumentClick);
		document.addEventListener('keydown', onKeyDown);

		overlay._homeArtworkOverlayCleanup = function () {
			document.removeEventListener('click', onDocumentClick);
			document.removeEventListener('keydown', onKeyDown);

			if (activeTimeline) {
				activeTimeline.kill();
			}

			gsap.killTweensOf(overlay);
			overlayImage.removeAttribute('src');
			overlayImage.alt = '';

			if (overlayMetaSize) {
				overlayMetaSize.textContent = '';
			}

			if (overlayMetaMedium) {
				overlayMetaMedium.textContent = '';
			}

			if (overlayMetaMaterial) {
				overlayMetaMaterial.textContent = '';
			}

			if (overlayBuy) {
				overlayBuy.textContent = '';
			}

			gsap.set(overlay, { clearProps: 'all' });
			overlay.classList.remove('is-open');
			overlay.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('no-scroll');
		};

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_init);

